import React, { useState, useEffect } from 'react';
import '../styles/card.css'; // Your custom CSS
import axios from 'axios';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Card = () => {
  const [records, setRecords] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [selectedBusinessCard, setSelectedBusinessCard] = useState(null);
  const [selectedProfilePic, setSelectedProfilePic] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 16; // Number of cards per page

  const api_url = process.env.REACT_APP_API_URL;
  const img_url = "https://joozyvendorsbusinesscards.americanholdings.lk"

  useEffect(() => {
    axios.get(`${api_url}/api/vendor`)
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          setRecords(response.data);
        } else {
          console.error('Invalid data received');
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [api_url]);

  const filteredRecords = () => {
    return records.filter((record) =>
      [record.Customer, record.Country, record.Source, record.CategoryName, record.Email].some((field) =>
        field?.toLowerCase().includes(searchText.toLowerCase())
      ) || record.Contact?.toString().includes(searchText)
    );
  };

  const openModal = (type, value) => {
    if (type === 'businessCard') setSelectedBusinessCard(value);
    if (type === 'profilePic') setSelectedProfilePic(value);
    document.getElementById(`${type}Modal`).style.display = 'block';
  };

  const closeModal = (type) => {
    if (type === 'businessCard') setSelectedBusinessCard(null);
    if (type === 'profilePic') setSelectedProfilePic(null);
    document.getElementById(`${type}Modal`).style.display = 'none';
  };

  const getPriorityClass = (priority) => {
    return priority === 'High' ? 'border-danger' : priority === 'Medium' ? 'border-warning' : 'border-success';
  };

   // Pagination Logic
   const totalPages = Math.ceil(filteredRecords().length / pageSize);
   const paginatedRecords = filteredRecords().slice((currentPage - 1) * pageSize, currentPage * pageSize);
 
   const handleNextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const handlePreviousPage = () => {
  if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

 

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Centralized Export Portal</h2>
      {/* Legend Section for Priority Colors */}
      <div className="row mb-4">
        <div className="col-md-12 text-center">
          <div className="d-inline-block mr-5">
            <span className="badge bg-danger">High Priority</span>
          </div>
          <div className="d-inline-block mr-5">
            <span className="badge bg-warning">Medium Priority</span>
          </div>
          <div className="d-inline-block">
            <span className="badge bg-success">Low Priority</span>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <input
          type="text"
          className="form-control custom-search-bar"
          placeholder="Search by customer name, country, etc."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <div className="row">
        {paginatedRecords.map((record) => (
          <div className="col-md-3 mb-4" key={record.Id}>
            <div className={`card h-100 ${getPriorityClass(record.Priority)}`}>
              <div className="profile-pic-container">
                <LazyLoadImage
                  src={`${img_url}/${record.ClientPic}`}
                  alt={record.Customer}
                  className="rounded-circle profile-pic"
                  effect="blur"
                />
              </div>
              <div className="card-body">
                <h5 className="card-title text-start">{record.Customer}</h5>
                <h6 className="card-subtitle mb-2 text-muted text-start">{record.CompanyName}</h6>
                <h6 className="card-subtitle mb-2 text-muted text-start">
                  {record.CategoryName || 'Unknown Category'} {record.Sub_Categories && `, ${record.Sub_Categories}`}
                </h6>
                <p className="card-text text-start"><strong>Source:</strong> {record.SourceName}</p>
                <p className="card-text text-start"><strong>Country:</strong> {record.Country}</p>
                <p className="card-text text-start"><strong>Contact:</strong> {record.Contact}</p>
                <p className="card-text text-start"><strong>Email:</strong> {record.Email}</p>
                <div className="mt-3 text-start">
                  <button className="btn btn-success btn-sm" onClick={() => window.open(`https://wa.me/${record.Contact.replace(/\D/g, '')}`, '_blank')}>WhatsApp</button>
                  <button className="btn btn-primary btn-sm" onClick={() => window.location.href = `tel:${record.Contact}`}>Phone</button>
                  <button className="btn btn-info btn-sm" onClick={() => window.location.href = `mailto:${record.Email}`}>Email</button>
                </div>
              </div>
              <div className="button-container">
                <button className="btn btn-warning btn-sm" onClick={() => openModal('businessCard', record.BusinessCard)}>
                  <i className="bi bi-file-earmark-person"></i>
                </button>
                <button className="btn btn-primary btn-sm" onClick={() => openModal('profilePic', record.ClientPic)}>
                  <i className="bi bi-person-circle"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div id="businessCardModal" className="modal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Business Card</h5>
              <button type="button" className="close" onClick={() => closeModal('businessCard')}>&times;</button>
            </div>
            <div className="modal-body">
              {selectedBusinessCard && <LazyLoadImage src={`${img_url}/${selectedBusinessCard}`} alt="Business Card" className="img-fluid" effect="blur" />}
            </div>
          </div>
        </div>
      </div>
      <div id="profilePicModal" className="modal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Profile Picture</h5>
              <button type="button" className="close" onClick={() => closeModal('profilePic')}>&times;</button>
            </div>
            <div className="modal-body">
              {selectedProfilePic && <LazyLoadImage src={`${img_url}/${selectedProfilePic}`} alt="Profile Picture" className="img-fluid" effect="blur" />}
            </div>
          </div>
        </div>
      </div>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-center mt-4">
        <button className="btn btn-primary mx-2" disabled={currentPage === 1} onClick={handlePreviousPage}>
          Previous
        </button>
        <span className="align-self-center">Page {currentPage} of {totalPages}</span>
        <button className="btn btn-primary mx-2" disabled={currentPage === totalPages} onClick={handleNextPage}>
          Next
        </button>
      </div>

    </div>
  );
};

export default Card;
